import * as d3 from "d3";
import surface from "./surface.svg";

export function drawPlanet(target, width, height, isMobile) {
  target.append("g").attr("id", "surface");

  d3.xml(surface).then((data) => {
    d3.select("#surface").node().append(data.documentElement);
  });
}



// WEBPACK FOOTER //
// ./src/components/portfolio/drawPlanet.js